import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditsafeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0509 23.7027C20.0509 23.7027 21.2936 15.0477 28.7059 15H37.3206C37.3206 15 35.6197 23.7027 28.5556 23.7027H20.0509Z",
			fill: "#EE2E24"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 34C11 34 12.2427 25.345 19.6514 25.2974H28.2661C28.2661 25.2974 26.5651 34 19.501 34H11Z",
			fill: "#EE2E24"
		})
	]
});
export default SvgCreditsafeIcon;
